import React from 'react';
import {motion} from 'framer-motion';
import Button from '../../components/ui/Button';

const HeroSection=()=> {
  return (
    <section className="relative h-[85vh] min-h-[600px] flex items-center justify-center overflow-hidden bg-sand">
      <div className="absolute inset-0 z-0">
        <img src="https://media-manager-c.questera.ai/greta-media/2f6847c5255962cb7ef6c818c843620d0179d6b0e810fa4ca1144f00d96707af10e5b2228b1b15861dc89ecefec6c49b/images/aW1hZ2UvanBlZw==/34d49536cdc7acb48329a72ac7376861.jpg" alt="Ube powder and fresh ube from Philippine family farms" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-r from-sand/90 via-sand/60 to-transparent"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8,ease: "easeOut"}}>
            <span className="text-ube font-semibold tracking-wider uppercase text-sm mb-4 block">GROWN AND DRIED IN THE PHILIPPINES</span>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-medium text-gray-900 leading-[1.1] mb-6 text-balance">
              Real 100% <br /><span className="text-ube">Philippine Ube</span><br />Powder.
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-xl leading-relaxed">
              Philippine ube from family farms — grown and dried in the Philippines, shipped from Manila, arriving through the Port of Los Angeles, California. No dyes. No fillers. No purple sweet potato.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button to="/shop" size="lg">Shop Ube</Button>
              <Button to="/wholesale" variant="outline" size="lg" className="bg-white/50 backdrop-blur-sm">Wholesale for Cafes</Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;